import {EntityField} from "../../../core/genericdocuments/EntityField";
import {EntityFieldDataType} from "../../../core/genericdocuments/EntityFieldDataType";
import {EntityFieldsDescriptor} from "../../../core/genericdocuments/EntityFieldsDescriptor";
import {baseDocumentFields} from "../BaseDocumentFields";
import {LookupEntities} from "../../../core/genericdocuments/ReferenceDetails";
import {OpomenaZaSudskuTaksuDocument} from "./OpomenaZaSudskuTaksuDocument";

// obavezno: datum zavodjenja, delovodni broj, datum dokumenta, broj dokumenta, partner, sektor
// opciono: opis, lista priloga
export const opomenaZaSudskuTaksuDocumentFields: IntercateKeysMap<OpomenaZaSudskuTaksuDocument, EntityField<OpomenaZaSudskuTaksuDocument>> = {
	...baseDocumentFields,
	clientId: {
		name: "clientId", dataType: EntityFieldDataType._reference, label: "Partner",
		referenceDetails: {
			lookupOptions: null,
			lookupEntity: LookupEntities.Customers
		},
		validator: { required: true },
		sortable: true,
		autocomplete: true
	},
	parentId: {
		name: "parentId", dataType: EntityFieldDataType._derived, label: "Parent",
		value: (item: { clientId: any; }) => item.clientId,
		hide: formState => true
	}
}

const documentFieldsArray: Array<EntityField<OpomenaZaSudskuTaksuDocument>> = [
	opomenaZaSudskuTaksuDocumentFields.indexingNumber,
	opomenaZaSudskuTaksuDocumentFields.indexingDate,
	opomenaZaSudskuTaksuDocumentFields.documentNumber,
	opomenaZaSudskuTaksuDocumentFields.documentDate,
	opomenaZaSudskuTaksuDocumentFields.assignedTo,
	opomenaZaSudskuTaksuDocumentFields.clientId,
	opomenaZaSudskuTaksuDocumentFields.sectorId,
	opomenaZaSudskuTaksuDocumentFields.tags,
	opomenaZaSudskuTaksuDocumentFields.description,
	opomenaZaSudskuTaksuDocumentFields.parentId
]

export const opomenaZaSudskuTaksuDocumentFieldsDescriptor: EntityFieldsDescriptor<OpomenaZaSudskuTaksuDocument> = {
	listFields: documentFieldsArray,
	createFormFields: documentFieldsArray,
	updateFormFields: documentFieldsArray
}
